import React from 'react'
import HeaderLeftUI from './HeaderLeftUI'
import PrivateHeaderRightUI from './PrivateHeaderRightUI'
import PrivateFooterUI from './PrivateFooterUI'
import PageUI from './PageUI'

const PrivatePageUI = ({context, className, messageList,
    // page params
    backLink, headerText, headerMessageKey, pageMessageList, subHeaderText,
    // content params
    dimension, centered, children,
  }) =>
  <PageUI
    context={context}
    className={className}
    dimension={dimension}
    centered={centered}
    children={children}
    headerLeft={
      <HeaderLeftUI
        context={context}
        backLink={backLink}
        headerText={headerText}
        messageList={messageList}
        headerMessageKey={headerMessageKey}
        subHeaderText={subHeaderText}
      />
    }
    headerRight={
      <PrivateHeaderRightUI context={context} messageList={pageMessageList} />
    }
    footer={
      <PrivateFooterUI context={context} messageList={pageMessageList} />
    }
  />

export default PrivatePageUI
